import { islandScopedDocumentFilter, sanityFetch } from '../../lib/sanity'

export const PLAYBOOK_QUERY = `*[_type == "itineraryPlaybook" && ${islandScopedDocumentFilter()} && slugPath == $slugPath][0]{
  title,
  slugPath,
  _updatedAt,
  axis,
  hero{
    subhead,
    primaryCtaLabel,
    primaryCtaUrlOverride,
    imageAlt,
    image{
      asset,
      "lqip": asset->metadata.lqip,
      alt
    }
  },
  who,
  anchorDays[]{
    _key,
    title,
    body,
    links[]{
      _key,
      "kind": select(
        _type == "externalLink" => "external",
        _type == "reference" => "internal",
        _type == "internalReference" => "internal",
        "unknown"
      ),
      "label": select(
        _type == "externalLink" => label,
        _type == "reference" => coalesce(@->name, @->title),
        _type == "internalReference" => coalesce(@->name, @->title),
        null
      ),
      "url": select(_type == "externalLink" => url, null),
      "docType": select(
        _type == "reference" => @->_type,
        _type == "internalReference" => @->_type,
        null
      ),
      "slug": select(
        _type == "reference" => select(
          @->_type == "blogPost" => @->slug.current,
          @->_type == "activity" => @->slug.current,
          @->_type == "restaurant" => @->slug.current,
          @->_type == "lodging" => @->slug.current,
          @->_type == "area" => @->slug.current,
          @->_type == "region" => @->slug.current,
          null
        ),
        _type == "internalReference" => select(
          @->_type == "blogPost" => @->slug.current,
          @->_type == "activity" => @->slug.current,
          @->_type == "restaurant" => @->slug.current,
          @->_type == "lodging" => @->slug.current,
          @->_type == "area" => @->slug.current,
          @->_type == "region" => @->slug.current,
          null
        ),
        null
      ),
      "image": select(
        _type == "reference" => select(
          @->_type == "activity" => @->images[0]{asset, alt},
          @->_type == "restaurant" => @->images[0]{asset, alt},
          @->_type == "lodging" => @->images[0]{asset, alt},
          @->_type == "area" => @->heroImage{asset, alt},
          @->_type == "region" => @->heroImage{asset, alt},
          @->_type == "blogPost" => @->mainImage{asset, alt},
          null
        ),
        _type == "internalReference" => select(
          @->_type == "activity" => @->images[0]{asset, alt},
          @->_type == "restaurant" => @->images[0]{asset, alt},
          @->_type == "lodging" => @->images[0]{asset, alt},
          @->_type == "area" => @->heroImage{asset, alt},
          @->_type == "region" => @->heroImage{asset, alt},
          @->_type == "blogPost" => @->mainImage{asset, alt},
          null
        ),
        null
      )
    },
    image{
      asset,
      "lqip": asset->metadata.lqip,
      alt
    }
  },
  modules[]{
    _key,
    title,
    when,
    body,
    links[]{
      _key,
      "kind": select(
        _type == "externalLink" => "external",
        _type == "reference" => "internal",
        _type == "internalReference" => "internal",
        "unknown"
      ),
      "label": select(
        _type == "externalLink" => label,
        _type == "reference" => coalesce(@->name, @->title),
        _type == "internalReference" => coalesce(@->name, @->title),
        null
      ),
      "url": select(_type == "externalLink" => url, null),
      "docType": select(
        _type == "reference" => @->_type,
        _type == "internalReference" => @->_type,
        null
      ),
      "slug": select(
        _type == "reference" => select(
          @->_type == "blogPost" => @->slug.current,
          @->_type == "activity" => @->slug.current,
          @->_type == "restaurant" => @->slug.current,
          @->_type == "lodging" => @->slug.current,
          @->_type == "area" => @->slug.current,
          @->_type == "region" => @->slug.current,
          null
        ),
        _type == "internalReference" => select(
          @->_type == "blogPost" => @->slug.current,
          @->_type == "activity" => @->slug.current,
          @->_type == "restaurant" => @->slug.current,
          @->_type == "lodging" => @->slug.current,
          @->_type == "area" => @->slug.current,
          @->_type == "region" => @->slug.current,
          null
        ),
        null
      ),
      "image": select(
        _type == "reference" => select(
          @->_type == "activity" => @->images[0]{asset, alt},
          @->_type == "restaurant" => @->images[0]{asset, alt},
          @->_type == "lodging" => @->images[0]{asset, alt},
          @->_type == "area" => @->heroImage{asset, alt},
          @->_type == "region" => @->heroImage{asset, alt},
          @->_type == "blogPost" => @->mainImage{asset, alt},
          null
        ),
        _type == "internalReference" => select(
          @->_type == "activity" => @->images[0]{asset, alt},
          @->_type == "restaurant" => @->images[0]{asset, alt},
          @->_type == "lodging" => @->images[0]{asset, alt},
          @->_type == "area" => @->heroImage{asset, alt},
          @->_type == "region" => @->heroImage{asset, alt},
          @->_type == "blogPost" => @->mainImage{asset, alt},
          null
        ),
        null
      )
    }
  },
  pacingSeason,
  faq[]{
    _key,
    question,
    answer
  },
  seo{
    titleTag,
    metaDescription,
  },
  lastReviewed
}`

export const PLAYBOOK_PATHS_QUERY = `*[_type == "itineraryPlaybook" && ${islandScopedDocumentFilter()} && defined(slugPath)]{
  "slugPath": slugPath,
  "_updatedAt": _updatedAt
}`

export async function fetchItineraryPlaybook(slugPath) {
  if (!slugPath) {
    return null
  }

  try {
    return await sanityFetch(PLAYBOOK_QUERY, { slugPath })
  } catch (error) {
    console.error('Failed to fetch itinerary playbook from Sanity', { slugPath, error })
    throw error
  }
}

export async function fetchItineraryPlaybookPaths() {
  try {
    return await sanityFetch(PLAYBOOK_PATHS_QUERY)
  } catch (error) {
    console.error('Failed to fetch itinerary playbook paths from Sanity', error)
    throw error
  }
}
